import { Component, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';
import { DateRangeBannerService } from '../../services/date-range-banner.service';

@Component({
	selector: 'app-lift-stats-r7',
	styleUrls: ['./lift-stats-r7.component.css'],
	templateUrl: './lift-stats-r7.component.html'
})
export class LiftStatsR7Component extends LiftStatsComponent implements OnInit {
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected dateRangeBannerService: DateRangeBannerService
	) {
		super(analyticsService, analyticsDataModel, dateRangeBannerService);
	}

	ngOnInit(): void {
		this.requestData();
	}
}
